module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfc-day vfc-week-number",
    style: ({
      borderRightColor: _vm.borderColor
    })
  }, [_c('span', {
    staticClass: "vfc-span-day"
  }, [_vm._v(_vm._s(_vm.number))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be34f98e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-functional-calendar/src/components/WeekNumbers.vue
// module id = 2543
// module chunks = 1